module.exports = __webpack_public_path__ + "img/InEinemAnderenLand.8bae1662.jpg";